export default function MapEquipmentListDirective() {
  return {
    restrict: 'E',
    template: require('./map-equipment-list.component.html'),
    transclude: true
  };
}